import React from 'react'
import { LatLngExpression } from 'leaflet'
import { Popup } from 'react-leaflet'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import EventRounded from '@mui/icons-material/EventRounded'
import Timelapse from '@mui/icons-material/Timelapse'
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined'
import VerifiedRounded from '@mui/icons-material/VerifiedRounded'
import HomeWorkRounded from '@mui/icons-material/HomeWorkRounded'
import EnhancedMarker from '../enhanced-marker/enhanced-marker'

type Props = {
  position: LatLngExpression
  workStatus: 'not_started' | 'started' | 'finished' | 'reviewed'
  workTitle: string
  locationName: string
  isLate: boolean
}

const WorkMarker: React.FC<Props> = ({ position, workStatus, workTitle, locationName, isLate }) => {
  const iconProps = statusToIcon(workStatus)
  return (
    <EnhancedMarker
      position={position}
      icon={
        <Avatar {...iconProps} variant='rounded' />
      }
    >
      <Popup className='marker-popup'>
        <Typography variant='h7' color={isLate ? "error.main" : "text.secondary"}>{workTitle}</Typography>
        <Typography variant='body1' color="text.secondary">{iconProps.children}{iconProps.title}</Typography>
        <Typography variant='body1' color="text.secondary"><HomeWorkRounded />{locationName}</Typography>
      </Popup>
    </EnhancedMarker>
  )
}

export default WorkMarker

function statusToIcon(status: Props['workStatus']) {
  var statuses = {
    not_started: { sx: { bgcolor: '#8E8E8E' }, children: <EventRounded />, title: 'A realizar' },
    started: { sx: { bgcolor: '#0245CC' }, children: <Timelapse />, title: 'Em andamento' },
    finished: { sx: { bgcolor: '#018923' }, children: <CheckCircleOutlined />, title: 'Finalizado' },
    reviewed: { sx: { bgcolor: '#006100' }, children: <VerifiedRounded />, title: 'Revisado' }
  }
  return statuses[status] || statuses.not_started
}
